import React from 'react';
import PropTypes from 'prop-types';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import throttle from 'lodash/throttle';

import t from '../../i18n';
import Icon from '../icon';
import './style.scss';

const SIZES = {
	xs: 20,
	sm: 24,
	md: 30,
	lg: 34,
};

const ACTIONS_HEIGHT = 30;

@observer
export default class DropDown extends React.Component {

	static propTypes = {
		items: PropTypes.array,
		aboveContent: PropTypes.any,
		selected: PropTypes.oneOfType([PropTypes.any, PropTypes.array]),
		comparator: PropTypes.func,
		getRef: PropTypes.func,
		listRef: PropTypes.func,
		renderItem: PropTypes.func,
		className: PropTypes.string,
		listClassName: PropTypes.string,
		listMaxHeight: PropTypes.number,
		inputValue: PropTypes.string,

		/**
		 * Размер (высота) dropdown, если число - высота в пикселях
		 */
		size: PropTypes.oneOfType([ PropTypes.number, PropTypes.oneOf(['xs', 'sm', 'md', 'lg']) ]),

		showValue: PropTypes.any,
		placeholder: PropTypes.any,
		noSearch: PropTypes.bool,
		disabled: PropTypes.bool,
		autoFocus: PropTypes.bool,
		isLoading: PropTypes.bool,
		actions: PropTypes.any,
		beforeInput: PropTypes.any,
		emptyContent: PropTypes.any,
		alwaysActive: PropTypes.bool,
		longStringTitle: PropTypes.bool,
		showClearButton: PropTypes.bool,
		inline: PropTypes.bool,
		inForm: PropTypes.bool,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func,
		onInputChange: PropTypes.func,
		onSelectItem: PropTypes.func,
		onPlaceholderOver: PropTypes.func,
		onPlaceholderOut: PropTypes.func,
		separateSelected: PropTypes.bool,
		position: PropTypes.string,
		autoActivate: PropTypes.bool,
	};

	static defaultProps = {
		alwaysActive: false,
		inline: false,
		isLoading: false,
		disabled: false,
		showClearButton: true,
		autoFocus: true,
		autoActivate: false,
		emptyContent: <div className="default-empty-content">{t('nothingFound')}</div>,
		aboveContent: null,
		separateSelected: false,
		beforeInput: null,
		position: null,
		size: 'md',
	};

	@observable active = false;
	@observable inputValue = '';

	constructor(props) {
		super(props);
		this.props = props;
		this.uiStore = props.uiStore;
		this.selectedIndex = -1;
		this.inputValue = props.inputValue || '' ;
		this.onResize = throttle(this.onResize, 250, { trailing: true });
	}

	componentDidMount() {
		this.mainContent = document.getElementById('main-content');
		document.addEventListener('mousedown', this.onMouseDown);
		window.addEventListener('resize', this.onResize);
		this.active = this.props.alwaysActive || this.props.autoActivate;
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onMouseDown);
		window.removeEventListener('resize', this.onResize);
	}

	componentDidUpdate(prevProps) {
		if (this.active && this.input && this.props.autoFocus) {
			this.input.focus();
		}
	}

	onMount = el => {
		this.node = el;
		if (el) {
			setTimeout(() => {
				// el.style.width = el.offsetWidth + 'px';
			}, 250);
		}
		if (this.props.getRef) this.props.getRef(el);
	};

	onResize = () => this.checkBounds();

	onListMount = el => {
		if (el) {
			this.listNode = el;
			this.checkBounds();
			if (this.props.listRef) this.props.listRef(el);
		}
	};

	onLoaderMount = el => {
/*
		console.log('onLoaderMount', el, this.node);
		if (el && this.node) {
			el.top = this.node.getBoundingClientRect().height;
		}
*/
	};

	checkBounds = () => {
		if (this.listNode && this.node) {
			const parentRect = this.node.getBoundingClientRect();
			const rect = this.listNode.getBoundingClientRect();
			// console.log('- 0', parentRect.y, parentRect.height, rect.height, document.body.clientHeight);

			let maxHeight = this.props.listMaxHeight || (300 + ACTIONS_HEIGHT + 2);
			if (typeof this.props.size === 'number') {
				maxHeight = this.props.size * 10 + ACTIONS_HEIGHT + 2;
			}
			else {
				const size = SIZES[this.props.size] || 30;
				maxHeight = size * 10 + ACTIONS_HEIGHT + 2;
			}
			console.log('size', this.props.size, 'maxHeight', maxHeight);

			const placeOnTop = () => {
				this.listNode.classList.add('on-top');
				// console.log('- on-top', this.node.offsetHeight, this.node.getBoundingClientRect().height);
				this.listNode.style.bottom = this.node.offsetHeight - 1 + 'px';
				this.listNode.style.maxHeight = Math.min(parentRect.top, maxHeight) + 'px';
				this.listNode.style.top = 'auto';
			};

			const placeOnBottom = () => {
				this.listNode.classList.remove('on-top');
				// console.log('-on-bottom', this.node.offsetHeight, this.node.getBoundingClientRect().height);
				this.listNode.style.top = this.node.offsetHeight - 1 + 'px';
				this.listNode.style.maxHeight = Math.min(window.innerHeight - parentRect.bottom, maxHeight) + 'px';
				this.listNode.style.bottom = 'auto';
			};

			const autoTop = () => {
				if (parentRect.y + parentRect.height + rect.height > window.innerHeight) {
					placeOnTop();
				}
				else {
					placeOnBottom();
				}
			};

			if (!/bottom/.test(this.props.position)) {
				autoTop();
			}
			else {
				placeOnBottom();
			}

			if (/right/.test(this.props.position)) {
				this.listNode.style.right = 0;
				this.listNode.style.left = 'auto';
			}

		}
	};

	onMouseDown = e => {
		if (this.active && this.node) {
			if (!this.node.contains(e.target)) {
				if (!this.props.alwaysActive) {
					this.active = false;
					if (this.props.onBlur) this.props.onBlur();
					// this.mainContent.removeEventListener('scroll', this.checkBounds);
				}
			}
		}
	};

	@action
	onInputChange(e) {
		this.inputValue = e.target.value;
		if (this.props.onInputChange) this.props.onInputChange(this.inputValue);
	}

	onInputFocus = e => {
		e.target.selectionStart = e.target.selectionEnd = e.target.value.length;
	};

	onInputBlur = e => {
		if (this.props.items && this.props.items.length === 0) {
			this.active = false;
			if (this.props.onBlur) this.props.onBlur();
		}
	};

	clearInput = e => {
		e.preventDefault();
		e.stopPropagation();
		this.inputValue = '';
		if (this.props.onInputChange) this.props.onInputChange(this.inputValue);
	};

	activate = e => {
		this.active = true;
		if (this.active && this.props.onFocus) this.props.onFocus(e);
	};

	deactivate = e => {
		if (this.active) {
			e.stopPropagation();
			this.active = false;
			if (this.props.onBlur) this.props.onBlur();
		}
	};

	selectItem = async (e, item, disabled) => {
		e.preventDefault();
		e.stopPropagation();

		if (this.busy) {
			// console.log('! busy');
			return;
		}
		this.busy = true;
		// console.log('busy <= true');

		if (!disabled) {
			const selectedValue = typeof item === "object" ? item.value : item;
			// console.log('DropDown: selectItem', item, 'selectedValue', selectedValue);
			if (this.props.onSelectItem) {
				await this.props.onSelectItem(selectedValue, item);
			}
		}
		if (!this.isMultiSelect() && !this.props.alwaysActive && !this.props.autoActivate) {
			this.active = false;
			if (this.props.onBlur) this.props.onBlur();
		}
		this.checkBounds();

		this.busy = false;
		// console.log('busy <= false');
	}

	isItemSelected(item) {
		const value = typeof item === "object" ? item.value : item;
		if (!this.isMultiSelect()) {
			const selected = this.props.selected && typeof this.props.selected === "object" ? this.props.selected.value : this.props.selected;
			return this.props.comparator ? this.props.comparator(value, selected) : value === selected;
		}
		return this.props.selected.find(v => {
			const selected = v && typeof v === "object" ? v.value : v;
			return this.props.comparator ? this.props.comparator(value, selected) : value === selected;
		});
	}

	isMultiSelect() {
		return this.props.selected && this.props.selected.constructor === Array;
	}

	onFilterOver = () => {
		if (this.node && !this.props.disabled) {
			this.node.classList.add('hovered');
		}
	};

	onFilterOut = () => {
		if (this.node) {
			this.node.classList.remove('hovered');
		}
	};

	placeholderOver = e => {
		e.stopPropagation();
		if (this.props.disabled) return;
		if (this.props.onPlaceholderOver) this.props.onPlaceholderOver();
	};

	placeholderOut = e => {
		e.stopPropagation();
		if (this.props.disabled) return;
		if (this.props.onPlaceholderOut) this.props.onPlaceholderOut();
	};

	onPlaceholderClick = e => {
		if (this.props.disabled) return;
		if (this.props.inForm || this.props.inColumn || this.props.inline) {
			e.stopPropagation();
			this.activate(e);
		}
	};

	onFilterClick = e => {
		e.stopPropagation();
		if (!this.props.disabled) this.activate(e);
	};

	render() {
		const input = this.active && !this.props.noSearch ?
			<>
				{this.props.beforeInput}
				<input
					type="text"
					className={'drop-down-search ' + (this.inputValue.length > 0 ? 'not-empty' : 'empty')}
					ref={node => this.input = node}
					value={this.inputValue}
					placeholder={this.props.placeholder || t('search')}
					onFocus={this.onInputFocus}
					onBlur={this.onInputBlur}
					onClick={e => e.stopPropagation()}
					onChange={e => this.onInputChange(e)}
				/>
			</>
			:
			<div className="placeholder"
			     onMouseOver={e => this.placeholderOver(e)}
			     onMouseOut={e => this.placeholderOut(e)}
			     onClick={e => this.onPlaceholderClick(e)}>
				{this.isMultiSelect() ?
					this.props.showValue || t('selectedCount') + ': ' + this.props.selected.length
					:
					this.props.showValue
				}
			</div>;

		this.selectedIndex = -1;

		let items = this.props.items.map((item, i) => {
			const selected = this.isItemSelected(item);
			let output = typeof item === "object" ? item.label : item;
			const disabled = typeof item === "object" && item.disabled === true;
			if (selected) {
				this.selectedIndex = i;
				if (this.props.separateSelected) {
					output = typeof selected === "object" ? selected.label : selected;
				}
			}
			const className = [
				'item',
				selected ? 'selected' : null,
				disabled ? 'disabled' : null,
				item.nomark ? 'no-mark' : 'with-mark',
			].join(' ');
			return <a href="#" key={i} className={className}
			          onClick={e => this.selectItem(e, item, disabled)}>{output}</a>;
		});

		if (this.props.items.length === 0) {
			if (this.props.emptyContent && !this.props.isLoading) {
				items = <div className="drop-down-empty">{this.props.emptyContent}</div>;
			}
			else {
				items = null;
			}
		}

		const clearBtn = <Icon icon="cancel" set="admin" className={'clear-btn'} onClick={this.clearInput}/>;

		const downIcon = <div className={'down-icon ' + (this.active ? 'inverted' : '')} onClick={this.deactivate}>
			<FontAwesomeIcon icon={faAngleDown}/>
		</div>;

		let className = [
			'drop-down',
			this.props.size && typeof this.props.size === 'string' ? 'drop-down-' + this.props.size : null, // compatibility
			this.props.size && typeof this.props.size === 'string' ? this.props.size : null,
			this.props.className || null,
			this.active ? 'active' : null,
			this.props.inline ? 'drop-down-inline' : null,
			this.props.actions ? 'with-actions' : null,
			this.props.alwaysActive ? 'always-active' : null,
			this.props.disabled ? 'disabled' : null,
		].join(' ');

		const style = {};
		if (typeof this.props.size === 'number') style.fontSize = (this.props.size / 2.5) + 'px';

		return <div className={className} ref={this.onMount} style={style}>
			{this.props.aboveContent}
			<div className="filter"
			     onMouseOver={this.onFilterOver}
			     onMouseOut={this.onFilterOut}
			     onClick={this.onFilterClick}>
				{input}
				{this.active && this.inputValue.length > 0 && this.props.showClearButton && clearBtn}
				{!this.props.alwaysActive && downIcon}
			</div>

			{this.active && (items || this.props.actions) &&
				<div className={'list ' + (this.props.listClassName || '')} ref={e => this.onListMount(e)}>
					{this.active && this.props.isLoading && <div className="drop-down-loading" ref={this.onLoaderMount}/>}
					<div className="items">{items}</div>
					{this.props.actions}
				</div>
			}
		</div>;
	}
}
